// Import model
import { FilterPickListItemRequest } from '../models/FilterPickListItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { PickListItemCondition } from '../models/PickListItemCondition';
import { PickListItemFields } from '../models/PickListItemFields';
import { PickListItemIndexedFields } from '../models/PickListItemIndexedFields';

// Import dependency serializers (for complex types)
import { PickListItemConditionSerializer } from './PickListItemConditionSerializer';
import { PickListItemFieldsSerializer } from './PickListItemFieldsSerializer';
import { PickListItemIndexedFieldsSerializer } from './PickListItemIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterPickListItemRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterPickListItemRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterPickListItemRequest instance
   */
  static deserialize(json: string): FilterPickListItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterPickListItemRequest instance
   */
  static fromObject(obj: any): FilterPickListItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterPickListItemRequest');
    }


    const instance: FilterPickListItemRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as PickListItemIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as PickListItemFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        PickListItemConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterPickListItemRequest instances
   */
  static deserializeArray(json: string): FilterPickListItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterPickListItemRequest instance to a JSON string
   */
  static serialize(instance: FilterPickListItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterPickListItemRequest instance to a plain object
   */
  static toObject(instance: FilterPickListItemRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        PickListItemConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterPickListItemRequest instances to a JSON string
   */
  static serializeArray(instances: FilterPickListItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
